var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.heroSchema.bgColor }, [
    _c(
      "div",
      {
        staticClass: "hero-banner-text__container",
        style: { "max-width": _vm.heroSchema.maxWidth }
      },
      [
        _c(
          "div",
          {
            staticClass: "hero-banner-text",
            class: [_vm.layoutHorizontal, _vm.layoutVertical, _vm.textAlign],
            style: _vm.backgroundStyles
          },
          [
            _vm.heroSchema.textLayout !== "two_column" || _vm.$mq === "mobile"
              ? _c(
                  "div",
                  { staticClass: "hero-banner-text__content-container" },
                  [
                    _vm.$mq === "mobile" &&
                    _vm.heroSchema.mobileLayout === "below" &&
                    (_vm.heroSchema.image.length > 0 ||
                      _vm.heroSchema.imageMobile > 0)
                      ? _c("div", {
                          staticClass: "hero-banner-text__image-mobile",
                          style: _vm.backgroundStylesMobile
                        })
                      : _vm._e(),
                    _c("div", { staticClass: "hero-banner-text__content" }, [
                      _vm.heroSchema.preHeading
                        ? _c(
                            "h4",
                            {
                              staticClass:
                                "preheader hero-banner-text__preheading",
                              class: _vm.heroSchema.preHeadingColor
                            },
                            [_vm._v(_vm._s(_vm.heroSchema.preHeading))]
                          )
                        : _vm._e(),
                      _vm.heroSchema.heading
                        ? _c(
                            "h2",
                            {
                              staticClass: "h1 hero-banner-text__heading",
                              class: _vm.heroSchema.headingColor
                            },
                            [_vm._v(_vm._s(_vm.heroSchema.heading))]
                          )
                        : _vm._e(),
                      _vm.heroSchema.subHeading
                        ? _c(
                            "h3",
                            {
                              staticClass:
                                "subheader hero-banner-text__subheading",
                              class: _vm.heroSchema.subHeadingColor
                            },
                            [_vm._v(_vm._s(_vm.heroSchema.subHeading))]
                          )
                        : _vm._e(),
                      _vm.heroSchema.copy
                        ? _c("div", {
                            staticClass:
                              "body-md hero-banner-text__body-copy client-generated",
                            class:
                              ((_obj = {}),
                              (_obj[_vm.heroSchema.copyColor] = true),
                              (_obj[
                                "hero-banner-text__body-copy-margin-bottom--none"
                              ] = !_vm.heroSchema.enableCta),
                              _obj),
                            domProps: { innerHTML: _vm._s(_vm.heroSchema.copy) }
                          })
                        : _vm._e(),
                      _vm.heroSchema.enableCta && _vm.heroSchema.ctaText
                        ? _c(
                            "div",
                            { staticClass: "hero-banner-text__cta-wrapper" },
                            [
                              _vm.heroSchema.ctaLayout.includes("button")
                                ? _c(
                                    "v-button",
                                    {
                                      staticClass: "hero-banner__cta",
                                      class: _vm.heroSchema.ctaLayout,
                                      attrs: {
                                        href: _vm.heroSchema.ctaUrl,
                                        tag: "a"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.heroSchema.ctaText))]
                                  )
                                : _vm._e(),
                              _vm.heroSchema.ctaLayout.includes("link")
                                ? _c(
                                    "v-link",
                                    {
                                      staticClass: "hero-banner__cta",
                                      class: _vm.heroSchema.ctaLayout,
                                      attrs: { href: _vm.heroSchema.ctaUrl }
                                    },
                                    [_vm._v(_vm._s(_vm.heroSchema.ctaText))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass: "hero-banner-text__content-container",
                    class: _vm.heroSchema.textLayout
                  },
                  [
                    _c("div", { staticClass: "hero-banner-text__content" }, [
                      _c(
                        "div",
                        { staticClass: "hero-banner-text__two-columns-left" },
                        [
                          _vm.heroSchema.preHeading
                            ? _c(
                                "h4",
                                {
                                  staticClass:
                                    "preheader hero-banner-text__preheading",
                                  class: _vm.heroSchema.preHeadingColor
                                },
                                [_vm._v(_vm._s(_vm.heroSchema.preHeading))]
                              )
                            : _vm._e(),
                          _vm.heroSchema.heading
                            ? _c(
                                "h2",
                                {
                                  staticClass: "h1 hero-banner-text__heading",
                                  class: _vm.heroSchema.headingColor
                                },
                                [_vm._v(_vm._s(_vm.heroSchema.heading))]
                              )
                            : _vm._e(),
                          _vm.heroSchema.subHeading
                            ? _c(
                                "h3",
                                {
                                  staticClass:
                                    "subheader hero-banner-text__subheading",
                                  class: _vm.heroSchema.subHeadingColor
                                },
                                [_vm._v(_vm._s(_vm.heroSchema.subHeading))]
                              )
                            : _vm._e()
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "hero-banner-text__two-columns-right" },
                        [
                          _vm.heroSchema.copy
                            ? _c("div", {
                                staticClass:
                                  "body-md hero-banner-text__body-copy client-generated",
                                class:
                                  ((_obj$1 = {}),
                                  (_obj$1[_vm.heroSchema.copyColor] = true),
                                  (_obj$1[
                                    "hero-banner-text__body-copy-margin-bottom--none"
                                  ] = !_vm.heroSchema.enableCta),
                                  _obj$1),
                                domProps: {
                                  innerHTML: _vm._s(_vm.heroSchema.copy)
                                }
                              })
                            : _vm._e(),
                          _vm.heroSchema.enableCta && _vm.heroSchema.ctaText
                            ? _c(
                                "div",
                                {
                                  staticClass: "hero-banner-text__cta-wrapper"
                                },
                                [
                                  _vm.heroSchema.ctaLayout.includes("button")
                                    ? _c(
                                        "v-button",
                                        {
                                          staticClass: "hero-banner__cta",
                                          class: _vm.heroSchema.ctaLayout,
                                          attrs: {
                                            href: _vm.heroSchema.ctaUrl,
                                            tag: "a"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.heroSchema.ctaText))]
                                      )
                                    : _vm._e(),
                                  _vm.heroSchema.ctaLayout.includes("link")
                                    ? _c(
                                        "v-link",
                                        {
                                          staticClass: "hero-banner__cta",
                                          class: _vm.heroSchema.ctaLayout,
                                          attrs: { href: _vm.heroSchema.ctaUrl }
                                        },
                                        [_vm._v(_vm._s(_vm.heroSchema.ctaText))]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  ]
                ),
            _vm.heroSchema.overlayEnable
              ? _c("div", {
                  staticClass: "hero-banner-text__overlay",
                  class: _vm.heroSchema.overlayColor,
                  style: _vm.overlayStyles
                })
              : _vm._e()
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }